<template>
  <BaseSimpleLayout class="support-shop-master-detail">
    <template #title>サポート店詳細</template>
    <template v-if="loadingFlag" #main>
      <BaseDataTable :table-data="detailTableData" :label-width="150" />
      <el-button
        type="info"
        size="large"
        @click="router.push('/master/supportshop')"
      >
        戻る
      </el-button>
      <ScreenPermissionGate code="SUPPORT_SHOP-BTN_EDIT">
        <el-button
          type="success"
          size="large"
          @click="router.push('/master/supportshop/edit')"
        >
          編集
        </el-button>
      </ScreenPermissionGate>
      <ScreenPermissionGate code="SUPPORT_SHOP-BTN_DELETE">
        <el-button type="danger" size="large" @click="dialogVisible = true">
          削除
        </el-button>
      </ScreenPermissionGate>
      <el-dialog v-model="dialogVisible" title="確認" width="30%">
        <span><b>このサポート店マスタを削除しますか。</b></span>
        <template #footer>
          <el-button size="large" @click="dialogVisible = false">
            キャンセル
          </el-button>
          <el-button size="large" type="danger" @click="deleteItem">
            削除
          </el-button>
        </template>
      </el-dialog>
    </template>
  </BaseSimpleLayout>
</template>

<script setup lang="ts">
  import { ref } from 'vue';
  import { useStore } from 'vuex';
  import router from '@/router';
  import BaseSimpleLayout from '@/components/BaseSimpleLayout.vue';
  import BaseDataTable from '@/components/BaseDataTable.vue';
  import { ElLoading } from 'element-plus';
  import ScreenPermissionGate from '@/components/ScreenPermissionGate.vue';
  import { DetailTableData } from '@/types/common';

  const props = defineProps({
    supportShopId: {
      type: String,
      required: true
    }
  });
  const store = useStore();
  const detailTableData = ref<DetailTableData[]>();
  const dialogVisible = ref(false);
  const loadingFlag = ref(false);

  const initialize = async () => {
    const loadingInstance = ElLoading.service({ fullscreen: true });
    await store.dispatch('supportShopMaster/fetch', props.supportShopId);
    const detailData = store.state.supportShopMaster.detailData;
    detailTableData.value = [
      {
        label: 'ID',
        value: detailData.id
      },
      {
        label: 'サポート店名',
        value: detailData.name
      },
      {
        label: '所属組合',
        value: detailData.affiliationUnion
      },
      {
        label: '郵便番号',
        value: detailData.zip
      },
      {
        label: '都道府県',
        value: detailData.prefecture
      },
      {
        label: '市区町村',
        value: detailData.city
      },
      {
        label: '住所',
        value: detailData.address
      },
      {
        label: '住所サブ',
        value: detailData.addressSub
      },
      {
        label: '電話番号',
        value: detailData.tel
      },
      {
        label: '携帯番号',
        value: detailData.mobileNumber
      },
      {
        label: '担当者',
        value: detailData.staffName
      }
    ];
    loadingInstance.close();
    loadingFlag.value = true;
  };
  const deleteItem = () => {
    store.dispatch('supportShopMaster/delete', props.supportShopId);
  };
  initialize();
</script>
<style lang="scss">
  .support-shop-master-detail {
    .el-table {
      width: 500px;
      margin: auto;
    }
    .el-button {
      margin: 20px 10px;
      font-weight: 600;
    }
  }
</style>
